export const ERRORS_UPDATED = 'ERRORS_UPDATED';
export const ERRORS_CLEARED = 'ERRORS_CLEARED';



// WEBPACK FOOTER //
// ./src/incab/common/actions/errors.js